import React from 'react';
import Reveal from './Reveal';
import { FAQS } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export default function FAQ() {
  return (
    <section id="faq" className="bg-[var(--ob-bg-alt)] py-24 md:py-32">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-12 px-5 md:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <Reveal>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
            FAQs
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-[var(--ob-ink)] md:text-5xl">
            Questions, answered.
          </h2>
          <p className="mt-5 text-lg text-[var(--ob-ink-soft)]">
            Everything you need to know before handing us the keys to your email channel.
          </p>
        </Reveal>

        <Reveal delay={100}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="mb-3 overflow-hidden rounded-2xl border border-[var(--ob-line)] bg-white px-5"
              >
                <AccordionTrigger className="py-5 text-left font-display text-lg font-bold text-[var(--ob-ink)] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-base leading-relaxed text-[var(--ob-ink-soft)]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
